module.exports = __webpack_public_path__ + "static/media/speed_encoding_updated.0b646d76.png";